<template>
  <v-container>
    <h2 class="titulo my-text">Datos del paciente</h2>
    <v-divider id="divider"></v-divider>
    <v-form ref="form" v-model="valid" fast-fail @submit.prevent="handleSubmit">
        <v-container>
          <v-row>
            <v-col
              cols="12"
              md="4"
            >
              <v-autocomplete
                v-model="datosPaciente.obraSocial"
                variant="solo"
                :items="opcionesOS"
                item-title="nombre"
                return-object
                :rules="obligatorio"
                :loading="cargandoSelects"
                label="Obra social"
                required
                class="asterisco"
                @update:model-value="datosPaciente.obraSocial?.grupoId == grupoBiomedId ? mostrarAlert() : null"
              >      
                <template v-slot:item="{ props, item }">
                    <v-list-item v-bind="props" :subtitle="item.raw.descripcion"></v-list-item>
                </template>   
              </v-autocomplete>    
            </v-col>

            <v-col
              cols="12"
              md="4"
            >
              <v-select
                v-model="datosPaciente.tipoDocumento"
                variant="solo"
                :items="obraSocialPorConfianza() ? opcionesDocs.filter(o => o != 'Carnet de Afiliado') : opcionesDocs"
                item-title="nombre"
                return-object
                :rules="obligatorio"
                :loading="cargandoSelects"
                label="Tipo de documento"
                required
                class="asterisco"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
            >
              <v-text-field
                v-model="datosPaciente.numeroDocumento"
                :rules="obligatorioAlfanumerico"
                :label="`Número de ${datosPaciente.tipoDocumento}`"
                hide-details="auto"
                variant="solo"
                required
                class="asterisco"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              :md="(esPorServicio() && !esPacienteExterno() ? 4 : 6)"
            >
            <v-select
                v-model="datosPaciente.sexo"
                variant="solo"
                :items="opcionesSexo"
                item-title="nombre"
                return-object
                :rules="obligatorio"
                label="Sexo"
                required
                class="asterisco"
              />
            </v-col>
            <v-col
              cols="12"
              v-if="!esPacienteExterno()"
              :md="((esPorServicio() ? 4 : 6) || (esACEAPP() ? 2 : 6))"
            >
              <v-select
                v-model="tipoIngreso"
                variant="solo"
                :items="opcionesIngreso"
                item-title="descripcion"
                return-object
                :rules="obligatorio"
                :loading="loadModo"
                label="Tipo de ingreso"
                required
                class="asterisco"
              />
            </v-col>
            <v-col
              cols="12"
              md="4"
              v-if="esACEAPP()"
            >
              <v-select
                v-model="tipoPrestacion"
                variant="solo"
                :items="opcionesTipoPrestacion"
                item-title="descripcion"
                item-value="valor"
                return-object
                :rules="obligatorio"
                label="Tipo de prestacion"
                required
                class="asterisco"
              />
            </v-col>
            <v-col
              cols="12"
              :md="esPacienteExterno() ? 6 : 4"
              v-if="(this.datosPaciente.obraSocial?.configuracionOS.requiereToken && this.datosPaciente.obraSocial?.nombre?.toUpperCase() != 'ACEAPP') || (this.datosPaciente.obraSocial?.nombre?.toUpperCase() == 'ACEAPP' && (this.esBajaComplejidad() || this.esBonoAdicional()))"
            ><!--la última expresión no puede ser this.esAltaComplejidad() porque eso hace que aparezca el input del token desde el inicio (sin que se hayan cargado datos) -->
              <v-text-field
                v-model="datosPaciente.token"
                label="Token"
                variant="solo"
                :rules="esPacienteExterno() || 
                this.datosPaciente.obraSocial?.configuracionOS?.aceptaTokenCero ? obligatorioAlfanumerico : obligatorioAlfanumericoSinCero"
                hide-details="auto"
                required
                class="asterisco"
                id="input-blanco"
                @update:model-value="alertTokenCero"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              :md="datosPaciente.obraSocial?.nombre == 'AVALIAN' ? 4 : 6"
            >
              <v-text-field
                v-if="(obraSocialPorConfianza() || datosPaciente.obraSocial?.configuracionOS.requiereNroAfiliadoManual)"
                v-model="datosPaciente.numeroAfiliado"
                :rules="obligatorioAlfanumerico"
                label="Número de afiliado"
                hide-details="auto"
                variant="solo"
                required
                class="asterisco"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="datosPaciente.obraSocial?.configuracionOS.requiereNroValidacionManual"
            >
              <v-text-field
                v-model="datosPaciente.nroTransaccion"
                label="Número de validación"
                variant="solo"
                :rules="aceptaNroAutorizacionCero ? obligatorioAlfanumerico : obligatorioAlfanumericoSinCero"
                hide-details="auto"
                required
                class="asterisco"
                id="input-blanco"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-btn class="mt-8" id="boton-verde" type="submit" :disabled="!valid || cargando" :loading="cargando" block >Validar</v-btn>
        </v-container>
    </v-form>
    <v-container class="d-flex justify-center align-center">
      <Loader v-if="cargando"></Loader>
    </v-container>
  </v-container>
  <AlertComponent
      :title="alertTitle"
      :text="alertText"
      :alertType="alertType"
      :showAlert="showAlert"
      :confirmButtonText="'Aceptar'"
      @close="showAlert = false"
    />
</template>

<style src="../assets/general.css"></style>

<script>
  /* eslint-disable */
  import PacienteLight from "@/interfaces/pacienteInterfaces"
  import DatosPaciente from "@/interfaces/pacienteInterfaces"
  import PacienteService from "@/api/PacienteService";
  import Loader from "./Loader.vue";
  import AlertComponent from "./AlertComponent.vue";
  import FacturadorService from "@/api/FacturadorService";
  import PrestacionService from "@/api/PrestacionService";
  import ImageInput from "./ImageInput.vue";
  import { Role } from "@/_helpers/role";
  import { obligatorio, obligatorioNumerico, obligatorioNumericoSinCero, obligatorioAlfanumerico, opcionalNumerico, obligatorioAlfanumericoSinCero, obligatorioNumeroAfiliado} from "@/_helpers/rules";
  
  const facturadorService = new FacturadorService();
  const prestacionService = new PrestacionService();
  const pacienteService = new PacienteService();

  export default {
    components: {
      Loader,
      AlertComponent,
      ImageInput
    },
    data: () => ({
      valid: false,
      cargando: false,
      cargandoSelects: false,
      opcionesOS:[],
      opcionesIngreso:[],
      opcionesDocs:["DNI", "Libreta Cívica","Libreta de Enrolamiento","Carnet de Afiliado"],
      opcionesSexo:["Femenino","Masculino", "X"],
      obligatorio : obligatorio,
      obligatorioNumerico: obligatorioNumerico,
      obligatorioAlfanumerico: obligatorioAlfanumerico,
      obligatorioAlfanumericoSinCero: obligatorioAlfanumericoSinCero,
      obligatorioNumericoSinCero: obligatorioNumericoSinCero,
      obligatorioNumeroAfiliado: obligatorioNumeroAfiliado,
      opcionalNumerico: opcionalNumerico,
      paciente : PacienteLight,
      datosPaciente: DatosPaciente = {
        tipoDocumento: "DNI",
      },
      tipoIngreso: null,
      tipoPrestacion: null,
      opcionesTipoPrestacion: [{descripcion: 'Alta complejidad', valor: 'ALTA_COMPLEJIDAD'}, {descripcion: 'Baja complejidad', valor: 'BAJA_COMPLEJIDAD'}, {descripcion: 'Bono adicional', valor: 'BONO_ADICIONAL'}],
      //variables para mostrar errores
      showAlert:false,
      alertTitle: 'Error',
      alertText: 'Credenciales inválidas.',
      alertType: 'error',
    }),
    computed: {
      grupoBiomedId(){
        return process.env.VUE_APP_GRUPO_BIOMED_ID;
      },
    },
    async mounted(){
      this.cargandoSelects = true;
      await this.getObrasSociales();
      if(this.opcionesOS.length == 1){
        this.datosPaciente.obraSocial = this.opcionesOS[0];
      }
      await this.getIngresos();
      this.cargandoSelects = false;
    },
    methods: {
      async handleSubmit() {
        if (this.valid) {
          this.cargando = true;
          this.datosPaciente.username = this.$store.getters.getUsername;
          let obraSocial = this.datosPaciente.obraSocial;
          if(this.datosPaciente.obraSocial.nombre.toUpperCase() == 'AVALIAN'){
            this.acomodarNumeroAfiliado()
          }
          if(this.esAltaComplejidad() && this.datosPaciente.obraSocial?.nombre?.toUpperCase() == 'ACEAPP'){
            this.datosPaciente.token = null;
          }
          const response = await pacienteService.getPaciente(this.datosPaciente);
          if(response && response.status === 200){
            this.paciente = response.data.paciente;
            const pedirDatos = response.data.completarDatos;
            this.$store.commit('setPaciente',this.paciente);
            this.$store.commit('setObraSocial', obraSocial);
            this.$store.commit('setConfiguracionesOS', obraSocial.configuracionOS);
            this.$store.commit('setPedirDatosPaciente', pedirDatos);
            localStorage.setItem('tipoPrestacion', JSON.stringify(this.tipoPrestacion));
            if(this.tipoIngreso){
              this.$store.commit('setIngreso',this.tipoIngreso);
            }
            this.cargando = false;
            if(this.esPacienteExterno()){
              this.$router.push('/reintegros/home');
            } 
            else{
              this.$router.push({ name: 'detalles-paciente' });
            }
          }
          else {
            this.cargando = false;
            this.alertTitle = 'Error';
            if(typeof response.data === 'string'){
              this.alertText = response.data;
            } else {
              this.alertText = "Error de sesión. Por favor inicie sesión nuevamente.";
            }
            this.alertType = 'error';
            this.showAlert = true;
          }
        }
      },
      esBajaComplejidad(){
        return this.tipoPrestacion?.valor === 'BAJA_COMPLEJIDAD';
      },
      esBonoAdicional(){
        return this.tipoPrestacion?.valor === 'BONO_ADICIONAL';
      },
      esAltaComplejidad(){ //tuve que agregarlo porque Bono y Baja requieren token, pero Alta Complejidad no
        return this.tipoPrestacion?.valor === 'ALTA_COMPLEJIDAD';
      },
      async getObrasSociales(){
        const facturadorId = this.$store.getters.getFacturador.id;
        const response = await facturadorService.getObrasSociales(facturadorId);
        if(response && response.status === 200){
          this.opcionesOS = response.data;
          const ioma = this.opcionesOS.find(os => os.nombre == 'IOMA');
          if(ioma){
            this.opcionesOS = this.opcionesOS.filter(os => os.nombre != 'IOMA');
            this.opcionesOS.unshift(ioma);
          }
        }
      },
      async getIngresos(){
        const response = await prestacionService.getIngresos();
        if(response && response.status === 200){
          this.opcionesIngreso = response.data;
          this.opcionesIngreso = this.opcionesIngreso.map((ingreso) => {
            return {
              descripcion: prestacionService.formatTipoIngreso(ingreso.descripcion),
              valor: ingreso.valor
            }
          });
        }
      },
      acomodarNumeroAfiliado(){
        let numeroSinEspacios = this.datosPaciente.numeroAfiliado.replace(/\s+/g, "");
        this.datosPaciente.numeroAfiliado = numeroSinEspacios.slice(0,-2)+'/'+numeroSinEspacios.slice(-2);
      },
      esPacienteExterno(){
        return this.$store.getters.getRole == Role.Paciente;
      },
      alertTokenCero(){
        if(!['IOMA', 'ACEAPP', 'ACEAPP MDQ'].includes(this.datosPaciente.obraSocial.nombre) && !this.esPacienteExterno() && this.datosPaciente.token == '0'){
          this.alertTitle= '¿Está seguro?';
          this.alertText= 'Usted va a autorizar una prestación SIN TOKEN. Esta acción es IRREVERSIBLE.';
          this.alertType= 'info';
          this.showAlert= true;
        }
      },
      obraSocialPorConfianza(){
        if(this.datosPaciente.obraSocial){
          return this.datosPaciente.obraSocial.configuracionOS.tipoServicio == 3;
        }
        return false;
      },
      cambiaOS(){
        if(this.obraSocialPorConfianza()){
          this.datosPaciente.tipoDocumento = 'Carnet de Afiliado';
        }
        else{
          this.datosPaciente.tipoDocumento = 'DNI';
        }
      },
      mostrarAlert(){
        this.alertTitle= 'Atención';
        this.alertText= 'Esta obra social autoriza a traves de otro sistema. Link a AutorizaMe: https://app.autorizame.com.ar/AutorizaMe/com.autorizame.login';
        this.alertType= 'info';
        this.showAlert= true;
      },
      esPorServicio(datos){
        return this.datosPaciente.obraSocial?.configuracionOS.tipoServicio == 0 || this.datosPaciente.obraSocial?.configuracionOS.tipoServicio == 4;
      },
      esACEAPP(){
        return this.datosPaciente.obraSocial?.nombre?.toUpperCase() == 'ACEAPP';
      }
    }
  };
</script>